import React, { useEffect, useState } from "react";
import StudentPerformancePDF from "./StudentPerformancePDF";
import axios from "../../axios";
import ModelForAssessmentType from "./ModelForAssessmentType";

function ExportStudentPDF({
  student,
  startDate,
  endDate,
  subjects,
  assessmentTypeId,
  studentAdmissionId,
  matchedSubjects,
  assessmentData,
}) {
  const [open, setOpen] = useState(false);
  const [supplementData, setSupplementData] = useState([]);
  useEffect(() => {
    if (
      !startDate ||
      !endDate ||
      !student?.id ||
      !student?.standard?.id ||
      !student?.section?.id
    )
      return;
    const fetchSupplementData = async () => {
      try {
        const response = await axios.get(
          `api/v1/performance/standard/${student?.standard?.id}/section/${
            student?.section?.id
          }/student/${
            student?.id
          }/percentageWithSupplementType/get?startDate=${startDate}&endDate=${endDate}&subjectId=${""}&assessmentEventId=${assessmentTypeId}`,
        );
        setSupplementData(response?.data?.data);
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchSupplementData();
  }, [assessmentTypeId]);

  return (
    <div className="p-6">
      <button className="showTablebutton" onClick={() => setOpen(true)}>
        Download Report
      </button>
      {open && (
        <ModelForAssessmentType
          data={assessmentData}
          setOpen={setOpen}
          student={student}
          startDate={startDate}
          endDate={endDate}
          subjects={subjects}
          assessmentTypeId={assessmentTypeId}
          studentAdmissionId={studentAdmissionId}
          matchedSubjects={matchedSubjects}
        />
      )}
    </div>
  );
}

export default ExportStudentPDF;
